import lazyImporter from '@/utils/lazyImporter'
import postTypeRoutes from './postType'

const postRoute = {
  component: lazyImporter('View'),
  meta: { title: 'posts', icon: 'event' },
  name: 'admin_post',
  path: '/post',
  redirect: { name: 'admin_post_list' },
  children: [
    {
      component: lazyImporter('post/PostList'),
      meta: { title: 'postList', hidden: true },
      name: 'admin_post_list',
      path: ''
    },
    {
      component: lazyImporter('post/PostUpdate'),
      meta: { title: 'postUpdate', hidden: true },
      name: 'admin_post_update',
      path: ':slug/update',
      props: true
    },
    {
      component: lazyImporter('post/PostAdd'),
      meta: { title: 'postAdd', hidden: true },
      name: 'admin_post_add',
      path: 'add'
    },
    postTypeRoutes
  ]
}

export default postRoute
